<div style="height: 100vh; display:flex; justify-content:center; align-items:center">
  <mat-card>
    <img mat-card-image src="assets/img/CabezoteLogin.fw.png" alt="Fundación de la mujer">
    <mat-card-title>
      Inicio de Sesión
    </mat-card-title>
    <mat-card-content>
      <form [formGroup]="loginForm" (ngSubmit)="login()">
        <p>
          <mat-form-field>
            <input type="text" formControlName="usuario" matInput placeholder="Usuario" />
          </mat-form-field>
        </p>
        <p>
          <mat-form-field>
            <input type="password" formControlName="pwd" matInput placeholder="Contraseña" />
          </mat-form-field>
        </p>
        <div>
          <button type="submit" [disabled]="!loginForm.valid" mat-raised-button>Iniciar sesión</button>
        </div>
      </form>
    </mat-card-content>
    <div class="row mt-3">
      <div class="col float-lg-left">
        <img alt="" class="img-fluid" src="assets/img/LogoInfopoint.fw.png" />
      </div>
      <div class="col">

      </div>
      <div class="col text-right">
        <a href="http://www.imglatam.com/web/wInicio.aspx" target="_blank">
          <img alt="" class="img-fluid" src="assets/img/LogoIMG.fw.png" />
        </a>
      </div>
    </div>
  </mat-card>
</div>
